/**
 * Logo Slider: arrows scroll the logo list one logo at a time and wrap at the ends; they show only when the logos
 * overflow. The list stays a native scroll-snap list (swipe, keyboard), so the content works without JS.
 */
(() => {
  const init = (root) => {
    const track = root.querySelector('.logo-slider__track');
    const controls = root.querySelector('.logo-slider__controls');
    if (!track || !controls) {
      return;
    }
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const update = () => {
      controls.hidden = track.scrollWidth <= track.clientWidth + 2;
    };

    controls.querySelectorAll('[data-direction]').forEach((button) => {
      button.addEventListener('click', () => {
        const item = track.querySelector('.logo-slider__item');
        const step = (item ? item.getBoundingClientRect().width : track.clientWidth) + parseFloat(getComputedStyle(track).columnGap || '0');
        const direction = Number(button.dataset.direction);
        const end = track.scrollWidth - track.clientWidth;
        let left = track.scrollLeft + direction * step;
        if (direction > 0 && track.scrollLeft >= end - 2) {
          left = 0;
        } else if (direction < 0 && track.scrollLeft <= 1) {
          left = end;
        }
        track.scrollTo({ left, behavior: motion.matches ? 'auto' : 'smooth' });
      });
    });

    new ResizeObserver(update).observe(track);
    update();
  };

  const boot = () => document.querySelectorAll('[data-logo-slider]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
